export const SIDEBAR_FULL_WIDTH = 260;
export const SIDEBAR_ICON_WIDTH = 72;
